<ng-container *ngIf="isEditable; else readOnly">
  <div class="tier-dropdown">
    <button class="btn btn-sm btn-outline-secondary" (click)="displayTierSelector()" [disabled]="disabled">
      Tier {{ tierNumber }}
      <i class="far fa-edit" aria-hidden="true"></i>
    </button>
  </div>
</ng-container>
<ng-template #readOnly>
  <div  class="tier-dropdown">
    <button class="btn btn-xs btn-default tier-button" disabled>
      Tier {{ tierNumber }}
    </button>
  </div>
</ng-template>
